(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2-minute-instant-eye-lift-product"]) return;
  try {
    
(function () {
  'use strict';

  // ── Gallery ────────────────────────────────────────────────────────────────
  function initGallery(sectionId) {
    var section   = document.getElementById('eil-section-' + sectionId);
    if (!section) return;

    var slides    = section.querySelectorAll('.eil-slide');
    var thumbBtns = section.querySelectorAll('.eil-thumb-btn');

    function showSlide(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('eil-slide--active', i === index);
      });
      thumbBtns.forEach(function (b, i) {
        b.classList.toggle('eil-thumb-btn--active', i === index);
        b.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showSlide(parseInt(btn.getAttribute('data-thumb-index'), 10));
      });
    });
  }

  // ── Variants ───────────────────────────────────────────────────────────────
  function initVariants(sectionId) {
    var section     = document.getElementById('eil-section-' + sectionId);
    if (!section) return;

    var variantsEl  = section.querySelector('#eil-variants-json-' + sectionId);
    if (!variantsEl) return;

    var variants       = JSON.parse(variantsEl.textContent);
    var hiddenInput    = section.querySelector('#eil-variant-input-' + sectionId);
    var atcBtn         = section.querySelector('#eil-atc-btn-' + sectionId);
    var optionBtns     = section.querySelectorAll('.eil-option-btn');
    var selectedValues = {};

    section.querySelectorAll('.eil-option-btn--active').forEach(function (b) {
      selectedValues[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
    });

    function getMatchingVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedValues[String(i + 1)] === opt;
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;
      hiddenInput.value = variant.id;

      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.querySelector('.eil-atc-text').textContent = 'ADD TO CART';
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.querySelector('.eil-atc-text').textContent = 'SOLD OUT';
      }

      section.querySelectorAll('.eil-option-selected-value').forEach(function (el) {
        var pos = el.getAttribute('data-option-position');
        el.textContent = selectedValues[pos] || '';
      });

      if (variant.featured_image) {
        var targetAlt = variant.featured_image.alt || '';
        var slides    = section.querySelectorAll('.eil-slide');
        var thumbBtns = section.querySelectorAll('.eil-thumb-btn');
        var matched   = false;

        slides.forEach(function (s, i) {
          var img = s.querySelector('img');
          if (!matched && img && img.alt === targetAlt) {
            slides.forEach(function (ss) { ss.classList.remove('eil-slide--active'); });
            thumbBtns.forEach(function (tb) { tb.classList.remove('eil-thumb-btn--active'); });
            s.classList.add('eil-slide--active');
            if (thumbBtns[i]) thumbBtns[i].classList.add('eil-thumb-btn--active');
            matched = true;
          }
        });
      }
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        var val = btn.getAttribute('data-option-value');

        section.querySelectorAll('.eil-option-btn[data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('eil-option-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('eil-option-btn--active');
        btn.setAttribute('aria-pressed', 'true');

        selectedValues[pos] = val;
        var variant = getMatchingVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  // ── AJAX Add-to-Cart ───────────────────────────────────────────────────────
  function initAddToCart(sectionId) {
    var section = document.getElementById('eil-section-' + sectionId);
    if (!section) return;

    var form   = section.querySelector('.eil-product-form');
    var atcBtn = section.querySelector('#eil-atc-btn-' + sectionId);
    if (!form || !atcBtn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;

      atcBtn.setAttribute('data-loading', 'true');
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;

          if (data.status === 422) {
            console.warn('[EIL] Cart add error:', data.description);
            return;
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', { bubbles: true })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );

          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .catch(function (err) {
          console.error('[EIL] Add to cart failed:', err);
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;
        });
    });
  }

  // ── Kaching thumbnail injection ────────────────────────────────────────────
  function initKachingThumbs(sectionId) {
    var sectionEl  = document.getElementById('eil-section-' + sectionId);
    var kachingDiv = document.getElementById('kaching-bundles-widget');
    if (!sectionEl || !kachingDiv) return;

    var imgSrc = sectionEl.getAttribute('data-featured-image');
    if (!imgSrc) return;

    function injectThumbs() {
      var rows = kachingDiv.querySelectorAll(
        '[class*="bundle-option"]:not([data-eil-thumb]),' +
        '[class*="bundleOption"]:not([data-eil-thumb]),' +
        '[class*="bundle-item"]:not([data-eil-thumb]),' +
        '[class*="bundleItem"]:not([data-eil-thumb]),' +
        '[class*="kaching-option"]:not([data-eil-thumb]),' +
        '[role="radio"]:not([data-eil-thumb])'
      );

      rows.forEach(function (row) {
        row.setAttribute('data-eil-thumb', '1');
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.className = 'eil-bundle-thumb';
        img.setAttribute('aria-hidden', 'true');
        var display = getComputedStyle(row).display;
        if (display !== 'flex' && display !== 'grid') {
          row.style.display = 'flex';
          row.style.alignItems = 'center';
        }
        row.insertBefore(img, row.firstChild);
      });
    }

    if (kachingDiv.children.length > 0) {
      injectThumbs();
      return;
    }

    var observer = new MutationObserver(function () {
      if (kachingDiv.children.length > 0) {
        setTimeout(injectThumbs, 200);
        observer.disconnect();
      }
    });
    observer.observe(kachingDiv, { childList: true, subtree: true });
  }

  // ── Product accordion ──────────────────────────────────────────────────────
  function initAccordion(sectionId) {
    var accordion = document.getElementById('eil-accordion-' + sectionId);
    if (!accordion) return;

    var triggers = accordion.querySelectorAll('.eil-accordion-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var body   = trigger.nextElementSibling;

        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var b = t.nextElementSibling;
          if (b) b.classList.remove('eil-accordion-body--open');
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.classList.add('eil-accordion-body--open');
        }
      });
    });
  }

  // ── FAQ accordion ──────────────────────────────────────────────────────────
  function initFaqAccordion(sectionId) {
    var faq = document.getElementById('eil-faq-' + sectionId);
    if (!faq) return;

    var triggers = faq.querySelectorAll('.eil-faq-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var body   = trigger.nextElementSibling;

        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var b = t.nextElementSibling;
          if (b) b.classList.remove('eil-faq-body--open');
        });

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.classList.add('eil-faq-body--open');
        }
      });
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init(sectionId) {
    initGallery(sectionId);
    initVariants(sectionId);
    initAddToCart(sectionId);
    initKachingThumbs(sectionId);
    initAccordion(sectionId);
    initFaqAccordion(sectionId);
  }

  document.querySelectorAll('[data-section-id]').forEach(function (el) {
    if (el.classList.contains('eil-section')) {
      init(el.getAttribute('data-section-id'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydrating-facial-toner-product"]) return;
  try {
    
(function () {
  'use strict';

  // ── Gallery: thumbnail clicks ──────────────────────────────────────────────
  function initGallery(sectionId) {
    var section   = document.getElementById('hft-section-' + sectionId);
    if (!section) return;

    var slides    = section.querySelectorAll('.hft-slide');
    var thumbBtns = section.querySelectorAll('.hft-thumb-btn');

    function showSlide(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('hft-slide--active', i === index);
      });
      thumbBtns.forEach(function (b, i) {
        b.classList.toggle('hft-thumb-btn--active', i === index);
        b.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        showSlide(idx);
      });
    });
  }

  // ── Variant selection ──────────────────────────────────────────────────────
  function initVariants(sectionId) {
    var section     = document.getElementById('hft-section-' + sectionId);
    if (!section) return;

    var variantsEl  = section.querySelector('#hft-variants-json-' + sectionId);
    if (!variantsEl) return; // single-variant product — nothing to do

    var variants    = JSON.parse(variantsEl.textContent);
    var hiddenInput = section.querySelector('#hft-variant-input-' + sectionId);
    var atcBtn      = section.querySelector('#hft-atc-btn-' + sectionId);
    var optionBtns  = section.querySelectorAll('.hft-option-btn');
    var selectedValues = {};

    // Seed initial selected values from active buttons
    section.querySelectorAll('.hft-option-btn--active').forEach(function (b) {
      selectedValues[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
    });

    function getMatchingVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedValues[String(i + 1)] === opt;
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;
      hiddenInput.value = variant.id;

      // Update button state
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.querySelector('.hft-atc-text').textContent = 'ADD TO CART';
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.querySelector('.hft-atc-text').textContent = 'SOLD OUT';
      }

      // Update selected value labels
      section.querySelectorAll('.hft-option-selected-value').forEach(function (el) {
        var pos = el.getAttribute('data-option-position');
        el.textContent = selectedValues[pos] || '';
      });

      // Swap to variant image if present
      if (variant.featured_image) {
        var targetAlt = variant.featured_image.alt || '';
        var slides    = section.querySelectorAll('.hft-slide');
        var thumbBtns = section.querySelectorAll('.hft-thumb-btn');
        var matched   = false;

        slides.forEach(function (s, i) {
          var img = s.querySelector('img');
          if (!matched && img && img.alt === targetAlt) {
            slides.forEach(function (ss) { ss.classList.remove('hft-slide--active'); });
            thumbBtns.forEach(function (tb) { tb.classList.remove('hft-thumb-btn--active'); });
            s.classList.add('hft-slide--active');
            if (thumbBtns[i]) thumbBtns[i].classList.add('hft-thumb-btn--active');
            matched = true;
          }
        });
      }
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        var val = btn.getAttribute('data-option-value');

        // Update selected state for this option group
        section.querySelectorAll('.hft-option-btn[data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('hft-option-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('hft-option-btn--active');
        btn.setAttribute('aria-pressed', 'true');

        selectedValues[pos] = val;
        var variant = getMatchingVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  // ── AJAX Add-to-Cart ───────────────────────────────────────────────────────
  function initAddToCart(sectionId) {
    var section = document.getElementById('hft-section-' + sectionId);
    if (!section) return;

    var form    = section.querySelector('.hft-product-form');
    var atcBtn  = section.querySelector('#hft-atc-btn-' + sectionId);
    if (!form || !atcBtn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;

      // Set loading state
      atcBtn.setAttribute('data-loading', 'true');
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;

          if (data.status === 422) {
            // Out of stock or error
            console.warn('[HFT] Cart add error:', data.description);
            return;
          }

          // Try to open the Horizon cart drawer via native CustomEvent
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', { bubbles: true })
          );

          // Also dispatch cart:refresh so count updates
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );

          // Fallback: update the Shopify cart count in the header
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              // Update any cart count elements the theme exposes
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .catch(function (err) {
          console.error('[HFT] Add to cart failed:', err);
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;
        });
    });
  }

  // ── Kaching thumbnail injection ────────────────────────────────────────────
  function initKachingThumbs(sectionId) {
    var sectionEl = document.getElementById('hft-section-' + sectionId);
    var kachingDiv = document.getElementById('kaching-bundles-widget');
    if (!sectionEl || !kachingDiv) return;

    var imgSrc = sectionEl.getAttribute('data-featured-image');
    if (!imgSrc) return;

    function injectThumbs() {
      // Target clickable bundle option rows — Kaching renders these as
      // list items or divs with role="radio" or class containing "option"/"bundle"
      var rows = kachingDiv.querySelectorAll(
        '[class*="bundle-option"]:not([data-hft-thumb]),' +
        '[class*="bundleOption"]:not([data-hft-thumb]),' +
        '[class*="bundle-item"]:not([data-hft-thumb]),' +
        '[class*="bundleItem"]:not([data-hft-thumb]),' +
        '[class*="kaching-option"]:not([data-hft-thumb]),' +
        '[role="radio"]:not([data-hft-thumb])'
      );

      rows.forEach(function (row) {
        row.setAttribute('data-hft-thumb', '1');
        // Only add if the row uses flex/grid and has no thumb yet
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.className = 'hft-bundle-thumb';
        img.setAttribute('aria-hidden', 'true');
        // Ensure row is flex so thumb sits to the left
        if (getComputedStyle(row).display === 'flex' || getComputedStyle(row).display === 'grid') {
          row.insertBefore(img, row.firstChild);
        } else {
          row.style.display = 'flex';
          row.style.alignItems = 'center';
          row.insertBefore(img, row.firstChild);
        }
      });
    }

    if (kachingDiv.children.length > 0) {
      injectThumbs();
      return;
    }

    var observer = new MutationObserver(function () {
      if (kachingDiv.children.length > 0) {
        // Small delay to let Kaching finish full render
        setTimeout(injectThumbs, 200);
        observer.disconnect();
      }
    });
    observer.observe(kachingDiv, { childList: true, subtree: true });
  }

  // ── Accordion ──────────────────────────────────────────────────────────────
  function initAccordion(sectionId) {
    var accordion = document.getElementById('hft-accordion-' + sectionId);
    if (!accordion) return;

    var triggers = accordion.querySelectorAll('.hft-accordion-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen   = trigger.getAttribute('aria-expanded') === 'true';
        var body     = trigger.nextElementSibling;

        // Close all
        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var b = t.nextElementSibling;
          if (b) b.classList.remove('hft-accordion-body--open');
        });

        // Open clicked one if it was closed
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.classList.add('hft-accordion-body--open');
        }
      });
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init(sectionId) {
    initGallery(sectionId);
    initVariants(sectionId);
    initAddToCart(sectionId);
    initKachingThumbs(sectionId);
    initAccordion(sectionId);
  }

  // Find the section ID from the rendered data attribute
  document.querySelectorAll('[data-section-id]').forEach(function (el) {
    if (el.classList.contains('hft-section')) {
      init(el.getAttribute('data-section-id'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-behind-twominuteeyelift"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function initFaq(sectionEl) {
    var faqList = sectionEl.querySelector('[id^="sbt-faq-"]');
    if (!faqList) return;

    faqList.querySelectorAll('.sbt-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sbt-faq__item');
        var isOpen = item.classList.contains('sbt-faq__item--open');

        // Close all
        faqList.querySelectorAll('.sbt-faq__item--open').forEach(function (openItem) {
          openItem.classList.remove('sbt-faq__item--open');
          openItem.querySelector('.sbt-faq__q').setAttribute('aria-expanded', 'false');
        });

        // Open clicked (if it was closed)
        if (!isOpen) {
          item.classList.add('sbt-faq__item--open');
          btn.setAttribute('aria-expanded', 'true');

          // Smooth scroll into view if needed
          var rect = item.getBoundingClientRect();
          if (rect.top < 80) {
            window.scrollBy({ top: rect.top - 100, behavior: 'smooth' });
          }
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      if (el.classList.contains('sbt-section')) {
        initFaq(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waterproof-makeup-remover-product"]) return;
  try {
    
(function () {
  'use strict';

  // ── Gallery: thumbnail clicks ──────────────────────────────────────────────
  function initGallery(sectionId) {
    var section   = document.getElementById('wmr-section-' + sectionId);
    if (!section) return;

    var slides    = section.querySelectorAll('.wmr-slide');
    var thumbBtns = section.querySelectorAll('.wmr-thumb-btn');

    function showSlide(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('wmr-slide--active', i === index);
      });
      thumbBtns.forEach(function (b, i) {
        b.classList.toggle('wmr-thumb-btn--active', i === index);
        b.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        showSlide(idx);
      });
    });
  }

  // ── Variant selection ──────────────────────────────────────────────────────
  function initVariants(sectionId) {
    var section     = document.getElementById('wmr-section-' + sectionId);
    if (!section) return;

    var variantsEl  = section.querySelector('#wmr-variants-json-' + sectionId);
    if (!variantsEl) return; // single-variant product — nothing to do

    var variants    = JSON.parse(variantsEl.textContent);
    var hiddenInput = section.querySelector('#wmr-variant-input-' + sectionId);
    var atcBtn      = section.querySelector('#wmr-atc-btn-' + sectionId);
    var optionBtns  = section.querySelectorAll('.wmr-option-btn');
    var selectedValues = {};

    // Seed initial selected values from active buttons
    section.querySelectorAll('.wmr-option-btn--active').forEach(function (b) {
      selectedValues[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
    });

    function getMatchingVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedValues[String(i + 1)] === opt;
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;
      hiddenInput.value = variant.id;

      // Update button state
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.querySelector('.wmr-atc-text').textContent = 'ADD TO CART';
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.querySelector('.wmr-atc-text').textContent = 'SOLD OUT';
      }

      // Update selected value labels
      section.querySelectorAll('.wmr-option-selected-value').forEach(function (el) {
        var pos = el.getAttribute('data-option-position');
        el.textContent = selectedValues[pos] || '';
      });

      // Swap to variant image if present
      if (variant.featured_image) {
        var targetAlt = variant.featured_image.alt || '';
        var slides    = section.querySelectorAll('.wmr-slide');
        var thumbBtns = section.querySelectorAll('.wmr-thumb-btn');
        var matched   = false;

        slides.forEach(function (s, i) {
          var img = s.querySelector('img');
          if (!matched && img && img.alt === targetAlt) {
            slides.forEach(function (ss) { ss.classList.remove('wmr-slide--active'); });
            thumbBtns.forEach(function (tb) { tb.classList.remove('wmr-thumb-btn--active'); });
            s.classList.add('wmr-slide--active');
            if (thumbBtns[i]) thumbBtns[i].classList.add('wmr-thumb-btn--active');
            matched = true;
          }
        });
      }
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        var val = btn.getAttribute('data-option-value');

        // Update selected state for this option group
        section.querySelectorAll('.wmr-option-btn[data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('wmr-option-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('wmr-option-btn--active');
        btn.setAttribute('aria-pressed', 'true');

        selectedValues[pos] = val;
        var variant = getMatchingVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  // ── AJAX Add-to-Cart ───────────────────────────────────────────────────────
  function initAddToCart(sectionId) {
    var section = document.getElementById('wmr-section-' + sectionId);
    if (!section) return;

    var form    = section.querySelector('.wmr-product-form');
    var atcBtn  = section.querySelector('#wmr-atc-btn-' + sectionId);
    if (!form || !atcBtn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;

      // Set loading state
      atcBtn.setAttribute('data-loading', 'true');
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;

          if (data.status === 422) {
            console.warn('[WMR] Cart add error:', data.description);
            return;
          }

          // Try to open the Horizon cart drawer via native CustomEvent
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', { bubbles: true })
          );

          // Also dispatch cart:refresh so count updates
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );

          // Fallback: update the Shopify cart count in the header
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .catch(function (err) {
          console.error('[WMR] Add to cart failed:', err);
          atcBtn.removeAttribute('data-loading');
          atcBtn.disabled = false;
        });
    });
  }

  // ── Kaching thumbnail injection ────────────────────────────────────────────
  function initKachingThumbs(sectionId) {
    var sectionEl  = document.getElementById('wmr-section-' + sectionId);
    var kachingDiv = document.getElementById('kaching-bundles-widget');
    if (!sectionEl || !kachingDiv) return;

    var imgSrc = sectionEl.getAttribute('data-featured-image');
    if (!imgSrc) return;

    function injectThumbs() {
      var rows = kachingDiv.querySelectorAll(
        '[class*="bundle-option"]:not([data-wmr-thumb]),' +
        '[class*="bundleOption"]:not([data-wmr-thumb]),' +
        '[class*="bundle-item"]:not([data-wmr-thumb]),' +
        '[class*="bundleItem"]:not([data-wmr-thumb]),' +
        '[class*="kaching-option"]:not([data-wmr-thumb]),' +
        '[role="radio"]:not([data-wmr-thumb])'
      );

      rows.forEach(function (row) {
        row.setAttribute('data-wmr-thumb', '1');
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.className = 'wmr-bundle-thumb';
        img.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(row).display === 'flex' || getComputedStyle(row).display === 'grid') {
          row.insertBefore(img, row.firstChild);
        } else {
          row.style.display = 'flex';
          row.style.alignItems = 'center';
          row.insertBefore(img, row.firstChild);
        }
      });
    }

    if (kachingDiv.children.length > 0) {
      injectThumbs();
      return;
    }

    var observer = new MutationObserver(function () {
      if (kachingDiv.children.length > 0) {
        setTimeout(injectThumbs, 200);
        observer.disconnect();
      }
    });
    observer.observe(kachingDiv, { childList: true, subtree: true });
  }

  // ── Accordion ──────────────────────────────────────────────────────────────
  function initAccordion(sectionId) {
    var accordion = document.getElementById('wmr-accordion-' + sectionId);
    if (!accordion) return;

    var triggers = accordion.querySelectorAll('.wmr-accordion-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var body   = trigger.nextElementSibling;

        // Close all
        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var b = t.nextElementSibling;
          if (b) b.classList.remove('wmr-accordion-body--open');
        });

        // Open clicked one if it was closed
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.classList.add('wmr-accordion-body--open');
        }
      });
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init(sectionId) {
    initGallery(sectionId);
    initVariants(sectionId);
    initAddToCart(sectionId);
    initKachingThumbs(sectionId);
    initAccordion(sectionId);
  }

  // Find the section ID from the rendered data attribute
  document.querySelectorAll('[data-section-id]').forEach(function (el) {
    if (el.classList.contains('wmr-section')) {
      init(el.getAttribute('data-section-id'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
